import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const useTracking = () => {

  const consent = useSelector((state) => state.consentCode)
  const UUID = useSelector((state) => state.uuid)
  const insurer = useSelector((state) => state.insurer)

  const [identifiedGA, setIdentifiedGA] = useState(false)

  useEffect(() => {
    if (consent && consent.ga === true && window.gtag && insurer && insurer.brandName) {
      window.gtag('set', 'user_properties', {
        company: `${insurer.brandName}`,
      });
    }
  }, [consent?.ga, insurer])

  useEffect(() => {
    if (UUID && !identifiedGA && consent && consent.ga === true && window.gtag) {
      window.gtag('set', { 'user_id': `${UUID}` })
      setIdentifiedGA(true)
    }
  }, [UUID, identifiedGA, consent?.ga])

}

export default useTracking